import { createApp } from 'vue';
import App from './App.vue';
import i18n from './i18n'
import { router } from './router';
import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'
// import VueVideoPlayer from '@videojs-player/vue'
import 'video.js/dist/video-js.css'
import axios from "axios";
import VueAxios from "vue-axios";
import { Toast, Area, Dialog, Space, Collapse, CollapseItem, ImagePreview, Empty, Popup, ConfigProvider} from 'vant';
import 'vant/lib/index.css';
import '@/sytles/index.css';
import 'vant/es/dialog/style';
import 'vant/es/notify/style';
import createStore from '@/store';
import { getUrlKey, clearStorage, tools } from './common/tools'
import VueVideoPlayer from '@videojs-player/vue'
import 'video.js/dist/video-js.css'
import VueClipboard from 'vue-clipboard2'
let token = getUrlKey('token')
let uid = getUrlKey('uid')
let langue = getUrlKey('langue')
let device = getUrlKey('device')

// token = '00af90691663d82d2b410d152012f2c2e44d4fa5'
// uid = '17'
clearStorage();
if(token != null){
    createStore.commit('token', token)
}
if(device != null){
    createStore.commit('device', device)
}
if(uid != null){
    createStore.commit('uid', uid)
}
if(langue != null){
    createStore.commit('langue', langue)
}
i18n.global.locale = createStore.getters.langue

const app = createApp(App);

app.use(VueAxios, axios);
app.use(createStore);
app.use(VuePlyr, {plyr: {}});
app.use(router);
app.use(Toast);
app.use(Area);
app.use(Space);
app.use(Collapse);
app.use(CollapseItem);
app.use(Empty);
app.use(Popup);
app.use(ConfigProvider);
app.use(ImagePreview);
app.use(VueVideoPlayer);
app.use(Dialog);
app.use(i18n);
app.use(VueClipboard)
app.mount('#app');